import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function getValueState(visualElement) {
  var state = [{}, {}];
  visualElement === null || visualElement === void 0 ? void 0 : visualElement.values.forEach(function (value, key) {
    state[0][key] = value.get();
    state[1][key] = value.getVelocity();
  });
  return state;
}
function resolveVariantFromProps(props, definition, custom, visualElement) {
  /**
   * If the variant definition is a function, resolve.
   */
  if (typeof definition === "function") {
    var _getValueState = getValueState(visualElement),
      _getValueState2 = _slicedToArray(_getValueState, 2),
      current = _getValueState2[0],
      velocity = _getValueState2[1];
    definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
  }
  /**
   * If the variant definition is a variant label, or
   * the function returned a variant label, resolve.
   */
  if (typeof definition === "string") {
    definition = props.variants && props.variants[definition];
  }
  /**
   * At this point we've resolved both functions and variant labels,
   * but the resolved variant label might itself have been a function.
   * If so, resolve. This can only have returned a valid target object.
   */
  if (typeof definition === "function") {
    var _getValueState3 = getValueState(visualElement),
      _getValueState4 = _slicedToArray(_getValueState3, 2),
      _current = _getValueState4[0],
      _velocity = _getValueState4[1];
    definition = definition(custom !== undefined ? custom : props.custom, _current, _velocity);
  }
  return definition;
}
export { resolveVariantFromProps };